/**
 * ч.1197 (рішення власника): сторінка «йде» — користувач підтвердив зміну
 * клієнта, вкладки і чернетки скинуто, далі повне перезавантаження.
 *
 * До вивантаження сторінка ще живе кілька мілісекунд: спрацьовує відкладений
 * запис чернетки (debounce useFormDraft), сторінка перейменовує свою вкладку.
 * Щоб скинуте не «воскресло» під ключем клієнта, якого покидаємо, сховища
 * вкладок і чернеток після цієї позначки нічого не пишуть.
 */
let leaving = false;

export function isPageLeaving(): boolean {
  return leaving;
}

export function markPageLeaving(): void {
  if (leaving) return;
  leaving = true;
  if (typeof window === 'undefined') return;
  // Сторінку повернули з памʼяті браузера («назад») — вона лишилась би
  // «замороженою» (вкладки і чернетки не зберігались би). Перезавантажуємо.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted && leaving) window.location.reload();
  });
}

/** Лише для тестів: стан модуля живе між тестами одного файлу. */
export function resetPageLeavingForTests(): void {
  leaving = false;
}
